import { Container, FederatedPointerEvent, Point, Sprite, Text, TextStyle } from "pixi.js";
import { CommonResourcesPackage } from "../../../../common/resources/CommonResourcesPackage";
import { BoosterType } from "../../../../common/models/data/BoosterType";
import { VictoryResourcesPackage } from "../resources/VictoryResourcesPackage";
import { GameFont } from "../../../../common/GameFont";
import { BoosterButton } from "../../../game/components/2d/BoosterButton";
import { UIButtonBase } from "../../../../common/components/UIButtonBase";
import { Event } from "event-system";

export class BoosterPurchaseComponent extends Container {
    private readonly button: BoosterButton;
    private readonly pricePanel: Sprite;
    private readonly priceText: Text;

    public get width(): number {
        return 144.12;
    }

    public get height(): number {
        return 135.78;
    }

    public get onPurchaseClick(): Event<UIButtonBase, FederatedPointerEvent> {
        return this.button.onUp;
    }

    public get count() {
        return this.button.count;
    }

    public set count(value: number) {
        this.button.count = value;
    }

    public constructor(
        commonResources: CommonResourcesPackage,
        victoryResources: VictoryResourcesPackage,
        type: BoosterType,
        count: number,
        level: number,
        price: number
    ) {
        super();
        this.button = new BoosterButton(commonResources, type, count, level, false);
        this.addChild(this.button);
        this.button.defaultScale = 144.12 / this.button.defaultView.width;
        this.button.countSubstratePosition = new Point(90, 90);

        this.pricePanel = new Sprite(victoryResources.assets_popups_victory_buster_purchase_substrate_png);
        this.priceText = new Text(price, new PriceTextStyle());

        this.priceText.position.set(60, 6);
        this.pricePanel.position.set((this.button.defaultView.width - this.pricePanel.width) * 0.5, 150);

        this.pricePanel.addChild(this.priceText);
        this.addChild(this.pricePanel);
    }

    public lockButton(): void {
        this.button.enabled = false;
    }

    public unlockButton(): void {
        this.button.enabled = true;
    }
}

class PriceTextStyle extends TextStyle {
    public constructor() {
        super({
            fontSize: 24,
            fill: "#FFFFFF",
            fontFamily: GameFont.Default,
            dropShadow: true,
            dropShadowColor: "#2B008C",
            dropShadowBlur: 0.5,
            dropShadowDistance: 4,
            dropShadowAngle: 1.77
        });
    }
}
